import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import axios from 'axios';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './services/msalInstance';
import { AlertProvider } from './contexts/AlertContext';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import MetricsEntry from './pages/MetricsEntry';
import PEDTracking from './pages/PEDTracking';
import Analytics from './pages/Analytics';
import ShowManagement from './pages/ShowManagement';
import Seasons from './pages/Seasons';
import CoachDashboard from './pages/CoachDashboard';
import Messages from './pages/Messages';
import Settings from './pages/Settings';
import Metrics from './pages/Metrics';
import AthleteTraining from './pages/training/AthleteTraining';
import TrainingPlans from './pages/training/TrainingPlans';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Retry once for genuine transient errors, but never for auth failures:
      // a 401 or a request cancelled because an auth redirect is underway
      // (see services/api.ts) would just stampede the interceptor again.
      retry: (failureCount, error) => {
        if (axios.isCancel(error)) return false;
        if (axios.isAxiosError(error) && error.response?.status === 401) return false;
        return failureCount < 1;
      },
    },
  },
});

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AlertProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/metrics/entry" element={<MetricsEntry />} />
              <Route path="/metrics" element={<Metrics />} />
              <Route path="/ped-tracking" element={<PEDTracking />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/shows" element={<ShowManagement />} />
              <Route path="/seasons" element={<Seasons />} />
              <Route path="/coach" element={<CoachDashboard />} />
              <Route path="/training" element={<AthleteTraining />} />
              <Route path="/training/plans" element={<TrainingPlans />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
          </AlertProvider>
        </Router>
      </QueryClientProvider>
    </MsalProvider>
  );
}

export default App;
